import { combineReducers } from 'redux';

import layouts from './layoutsReducer';
import userState from './userStateReducer';
import autosuggest from './autosuggestReducer';
import productInfo from './productInfoReducer';
import offerInfo from './offerInfoReducer';
import seoMeta from './seoMetadataReducer';
import inAppNotifications from './inAppNotificationsReducer';
import config from './configReducer';
import misc from './miscReducer';
import filters from './filtersReducer';
import swatches from './browseSwatchesReducer';
import modal from './modalReducer';
import compareWidgetData from './compareReducer';
import wishlistItemDetails from './wishlistReducer';
import comparePageData from './comparePageReducer';
import { compareBrandReducer, compareAddProductReducer } from './compareAddInReducer';
import productPage from './ProductReducers';
import ratingsAndReviews from './ratingsAndReviewsReducer/ratingsAndReviewsReducer';
import sellersPage from './sellersReducer';
import productSummary from './productSummaryReducer';
import reviewPageData from './reviewPageReducer';
import reviewsConfirmationPage from './reviewsConfirmationPageReducer';
import buyingGuides from './buyingGuidesReducer';
import tooltip from './tooltipReducer';
import deferredContent from './deferredContentReducer';
import pincodeData from './pincodeReducer';
import recentlyViewed from './recentlyViewedReducer';
import networkStatus from './networkStatusReducer';
import cartData from './cartPageReducer';
import saveForLaterData from './saveForLaterReducer';
import checkoutPage from './CheckoutReducers';
import payments from './PaymentReducers';
import paymentToken from './paymentTokenReducer';
import subscription from './subscriptionReducer';
import abExperiments from './abExperimentsReducer';
import giveAwayData from './giveAwayReducer';
import winnerList from './winnerListReducer';
import productBuyBack from './productBuyBackReducer';
import surveyState from './SurveyReducers/surveyStateReducer';
import singleReview from './singleReviewReducer';
import questionAndAnswer from './ProductQNAReducers';
import helpCentre from './HelpCentreReducers';
import reviewPageTitle from './ReviewPageTitleReducer';
import myAccount from './MyAccountReducers';
import sale from './saleReducer';
import selfServe from './SelfServeReducers';
import redeemVoucherReducer from './redeemVoucherReducer';
import gamification from './GamificationReducers';
import grocery from './GroceryReducers';
import lockInData from './lockInPageReducer';
import suggestions from './simpleSuggestionReducer';
import apiError from './apiErrorReducer';
import sellerDetails from './sellerDetailReducer';
import stickyBasket from './stickyBasketReducer';
import basket from './BasketPageReducer';
import pageDataV4 from './PageDataReducers';
import modalActionManager from './PageDataReducers/modalActionManagerReducer';
import infiniteMU from './infiniteMUReducer';
import { activateVip, claimedReward } from './VipReducers/activateVipReducer';
import lockinTnc from './VipReducers/lockinTncReducer';
import staticPage from './CheckoutReducers/staticPageReducer';
import floodLights from './FloodLightsReducer';
import userAddressData from './userAddressReducer';
import locationUpdate from './locationUpdateReducer';
import productServiceabilityInfo from './productServiceabilityReducer';
import validate2Fa from 'reducers/2faReducer';
import saalListingsData from 'reducers/SaalDataReducer';
import actionViewReducer from 'reducers/actionViewReducer';
import notifPrefsAccordion from 'reducers/NotifPrefsAccordionReducer';
import TravelSearchData from 'reducers/TravelReducers/SearchWidgetReducer';
import FareCalendarData from 'reducers/TravelReducers/FareCalendarReducer';
import TravelSearchValidation from 'reducers/TravelReducers/SearchValidationReducer';
import sectionSlotData from 'reducers/SectionDataReducer/sectionInfoReducer';
import cityAutoSuggestion from 'reducers/TravelReducers/cityAutoSuggestionReducer';
import wiggleValidationData from 'reducers/TravelReducers/wiggleValidationReducer';
import cbcApplyReducer from 'reducers/cbcApplyReducer';

const reducers = {
	abExperiments,
	activateVip,
	autosuggest,
	basket,
	buyingGuides,
	cartData,
	saveForLaterData,
	checkoutPage,
	claimedReward,
	compareAddProductData: compareAddProductReducer,
	compareBrandData: compareBrandReducer,
	comparePageData,
	compareWidgetData,
	config,
	deferredContent,
	filters,
	gamification,
	giveAwayData,
	grocery,
	helpCentre,
	inAppNotifications,
	infiniteMU,
	layouts,
	lockInData,
	lockinTnc,
	staticPage,
	misc,
	modal,
	modalActionManager,
	myAccount,
	networkStatus,
	offerInfo,
	pageDataV4,
	payments,
	paymentToken,
	pincodeData,
	productBuyBack,
	productInfo,
	productPage,
	productSummary,
	questionAndAnswer,
	ratingsAndReviews,
	recentlyViewed,
	reviewPageData,
	reviewPageTitle,
	reviewsConfirmationPage,
	saalListingsData,
	sale,
	selfServe,
	sellerDetails,
	sellersPage,
	seoMeta,
	singleReview,
	stickyBasket,
	subscription,
	suggestions,
	surveyState,
	swatches,
	tooltip,
	userState,
	winnerList,
	wishlistItemDetails,
	redeemVoucherReducer,
	apiError,
	floodLights,
	userAddressData,
	locationUpdate,
	productServiceabilityInfo,
	validate2Fa,
	actionViewReducer,
	notifPrefsAccordion,
	TravelSearchData,
	TravelSearchValidation,
	FareCalendarData,
	cityAutoSuggestion,
	sectionSlotData,
	wiggleValidationData,
	cbcApplyReducer
};

export default combineReducers(reducers);
